
// Handles filter selection in product overview and category product overview
const productsFilter = {
  init: function() {
    const filterDropdowns = document.querySelectorAll('.productscontainer__dropdown-filter');

    filterDropdowns.forEach(dropdown => {
      this.bind(dropdown)
    })
  },
  bind: function(dropdown)  {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const filterQuery = urlParams.get('filter')
    const coordinates = dropdown.getBoundingClientRect()
    if (filterQuery) {
      window.scrollTo(coordinates.x, coordinates.y-80)
      dropdown.value = filterQuery
    }

   dropdown.addEventListener("change", () => {
    if (dropdown.value) {
      this.filter(dropdown.value)
    }
   })
  },

  filter(filterValue) {
    const filterUrl = `${window.location.origin}${window.location.pathname}?filter=${filterValue}`

    window.location.href = filterUrl
  },
};

productsFilter.initialize = () => {
  productsFilter.init();
};

module.exports = productsFilter;
